import { FIELD_TYPES } from "constants/template-field-type";
import ThemeConfig from "segments/core-configs/theme-config";
import FullParagraphFieldsConfig from "segments/desktop/core-components/full-paragraph/fields-config";
import ProductsTabs from "segments/desktop/core-components/products-tabs/fields-config";

const { tabs, ...ProductTabsRestOfProps } = ProductsTabs;
const { bodyColor, titleColor, textColor, topic, mobileTextAlign, textAlign, buttonConfig, ...restOfParagraphConfig } =
  FullParagraphFieldsConfig;

export default {
  type: FIELD_TYPES.NESTED,
  label: "Side By Side Product Switcher With Product",
  fields: {
    ...ThemeConfig,
    reverseOrder: { type: FIELD_TYPES.BOOLEAN, label: "Reverse side by side order" },
    productTabs: {
      type: FIELD_TYPES.NESTED,
      label: "Product tabs",
      fields: {
        ...ProductTabsRestOfProps,
        tabs: {
          type: FIELD_TYPES.MULTIPLE_NESTED,
          label: "Tabs",
          nestedConfig: {
            type: FIELD_TYPES.NESTED,
            fields: {
              productType: { type: FIELD_TYPES.PRODUCTS, label: "Product type" },
              ...tabs.nestedConfig.fields,
              fullParagraph: {
                type: FIELD_TYPES.NESTED,
                label: "Full paragraph",
                fields: {
                  marginTop: { type: FIELD_TYPES.TEXT, label: "Margin top" },
                  ...restOfParagraphConfig,
                  buttonConfig: {
                    type: FIELD_TYPES.NESTED,
                    label: "Button",
                    fields: {
                      additionalText: {
                        type: FIELD_TYPES.TEXT,
                        label: "Additional text (monday markup supported)"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};
